const LocalesFindJobsEnum = Object.freeze({
  fr: 'Rechercher un emploi',
  de: 'Jobs finden',
  cs: 'Nabídka práce',
  sk: 'Vyhľadajte',
  es: 'Buscar empleo',
})

export default LocalesFindJobsEnum
